import { connect } from 'react-redux'

import { setActiveAudio } from '../../../common/actions/searchPage'
import AudioPlayerSmall from './audioPlayerSmall'

const mapStateToProps = (state, ownProps) => {
  const { searchPage: { activeAudio } } = state

  return {
    isActive: ownProps.src && ownProps.src === activeAudio
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    onPlay: () => dispatch(setActiveAudio(ownProps.src))
  }
}

const AudioPlayerSmallContainer = connect(mapStateToProps, mapDispatchToProps)(
  AudioPlayerSmall
)

export default AudioPlayerSmallContainer



// WEBPACK FOOTER //
// ./client/components/audio/audioPlayerSmallContainer.js